// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

class productInfo extends HTMLElement {

  constructor() {
    super();
    this.productForm = this.querySelector('product-form');
    this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
    this.quantityInputElement?.addEventListener('change', () => {
      this.handleQuantityInput();
    });
    //
    this.productColors = this.querySelector('product-colors');
    this.currentProductColorLabel = this.querySelector('[data-product-colors="current"]');
    if(this.currentProductColorLabel) {
      const currentValue = this.currentProductColorLabel.textContent;
      this.productColorsLinks = this.productColors?.querySelectorAll('a');
      this.productColorsLinks?.forEach(link => {
        ['mouseover','click'].forEach( evt =>
          link.addEventListener(evt, ()=>{
            this.currentProductColorLabel.textContent = link.getAttribute('title');
          })
        );
        link.addEventListener('mouseleave', ()=>{
          this.currentProductColorLabel.textContent = currentValue;
        })
      });
    }
    // Product sizes hover functionality
    this.productSizes = this.querySelector('[data-product-sizes-wrapper]');
    this.currentProductSizeLabel = this.querySelector('[data-product-sizes="current"]');
    if (this.currentProductSizeLabel) {
      const currentSizeValue = this.currentProductSizeLabel.textContent;
      this.productSizesLinks = this.productSizes?.querySelectorAll('a');
      this.productSizesLinks?.forEach(link => {
        ['mouseover', 'click'].forEach(evt =>
          link.addEventListener(evt, () => {
            this.currentProductSizeLabel.textContent = link.getAttribute('title');
          })
        );
        link.addEventListener('mouseleave', () => {
          this.currentProductSizeLabel.textContent = currentSizeValue;
        });
      });
    }
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }
}

if(!customElements.get('product-info')) {
  customElements.define('product-info', productInfo);
}

// Open tabs when clicked on scroll to buttons
function moreInfoTab() {
  const scrollToButtons = document.querySelectorAll('[data-product-scroll-button]'); // get all product scroll to buttons

  if (scrollToButtons) { // if the buttons exist..
    scrollToButtons.forEach(scrollToButton => {
      const scrollToTabId = scrollToButton.getAttribute('data-tab-id'); // get tab id from scroll button
      const scrollToTab = document.querySelector('[data-tab="'+scrollToTabId+'"]'); // select tab with same id

      // if clicked on scroll to button, open its tab
      scrollToButton.addEventListener('click', function() {
        scrollToTab.open = true;
      });
    });
  }
}
moreInfoTab();
